import { FC, useState } from 'react';
import { ItemTabs } from '../ItemTabs';
import css from './index.module.scss';
import * as Icon from '@/components/UI/svg/delta2max/IntroIcon';
import NextImage from '@/components/NextImage';
import { intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

const tabsIdxMap: any = {
    eu: [0, 1, 2, 3],
    cn: [3, 0, 2, 1],
    au: [1, 0, 2, 3],
};

export const ZEComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [activeIdx, setActiveIdx] = useState(tabsIdxMap[locale]?.[0] ?? tabsIdxMap.eu[0]);

    const tabsMap: any = {
        eu: [t('sec14_usage1_name'), t('sec14_usage2_name'), t('sec14_usage3_name'), t('sec14_usage4_name')],
        cn: [t('sec14_usage2_name'), t('sec14_usage4_name'), t('sec14_usage3_name'), t('sec14_usage1_name')],
        au: [t('sec14_usage2_name'), t('sec14_usage1_name'), t('sec14_usage3_name'), t('sec14_usage4_name')],
    };

    return (
        <div className={`${css.ZEComp} GtmModuleData-section`} data-section-id={css.ZEComp} data-section-title={t('sec14_title')}>
            <div className="subtitle">{t('sec14_subtitle')}</div>
            <div className="title">{t('sec14_title')}</div>
            <ItemTabs
                title={t('sec14_title')}
                list={tabsMap[locale] || tabsMap.eu}
                onTabClick={(idx: number) => {
                    const idex = tabsIdxMap[locale]?.[idx] ?? tabsIdxMap.eu[idx];
                    setActiveIdx(Number(idex));
                }}
            />
            {activeIdx === 0 && (
                <div className="content-box">
                    <div className="img-box">
                        {!['jp', 'cn'].includes(locale) && (
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-1.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/13-1.jpg')}
                                alt={t('sec14_title')}
                                aria-label={t('sec14_title')}
                            />
                        )}
                        {locale === 'jp' && (
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-1_jp.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/13-1_jp.jpg')}
                                alt={t('sec14_title')}
                                aria-label={t('sec14_title')}
                            />
                        )}
                        {locale === 'cn' && (
                            <NextImage src={require(`@publicLocal/delta2max/teaser/pc/eu/13-1_cn.jpg`)} alt={t('sec14_title')} aria-label={t('sec14_title')} />
                        )}
                    </div>
                    <div className="icon-box-wrapper wrapper-0">
                        <div className="icon-box">
                            <Icon.IntroIconA />
                            <div className="desc">{t('sec14_usage1_item1')}</div>
                            <div className="data-text">
                                <span className="num">14</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconB />
                            <div className="desc">{t('sec14_usage1_item2')}</div>
                            <div className="data-text">
                                <span className="num">97</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconC />
                            <div className="desc">{t('sec14_usage1_item3')}</div>
                            <div className="data-text">
                                <span className="num">15</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconD />
                            <div className="desc">{t('sec14_usage1_item4')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.3)}</span>
                                <span className="unit">{locale === 'fr' ? t('sec14_hr') : t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconE />
                            <div className="desc">{t('sec14_usage1_item5')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 3.3)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconF />
                            <div className="desc">{t('sec14_usage1_item6')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 3.3)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeIdx === 1 && (
                <div className="content-box">
                    <div className="img-box">
                        {!['jp', 'cn'].includes(locale) && (
                            <>
                                {locale === 'au' ? (
                                    <NextImage
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/au_7.jpg')}
                                        alt={t('sec14_title')}
                                        aria-label={t('sec14_title')}
                                    />
                                ) : (
                                    <NextImage
                                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-2.webp')}
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/13-2.jpg')}
                                        alt={t('sec14_title')}
                                        aria-label={t('sec14_title')}
                                    />
                                )}
                            </>
                        )}
                        {locale === 'jp' && (
                            <NextImage
                                webpSrc={require(`@publicLocal/delta2max/teaser/pc/eu/13-2_jp.webp`)}
                                src={require(`@publicLocal/delta2max/teaser/pc/eu/13-2_jp.jpg`)}
                                alt={t('sec14_title')}
                                aria-label={t('sec14_title')}
                            />
                        )}
                        {locale === 'cn' && (
                            <NextImage src={require(`@publicLocal/delta2max/teaser/pc/eu/13-2_cn.jpg`)} alt={t('sec14_title')} aria-label={t('sec14_title')} />
                        )}
                    </div>
                    <div className="icon-box-wrapper wrapper-1">
                        <div className="icon-box">
                            <Icon.IntroIconG />
                            <div className="desc">{t('sec14_usage2_item1')}</div>
                            <div className="data-text">
                                <span className="num">29</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconH />
                            <div className="desc">{t('sec14_usage2_item2')}</div>
                            <div className="data-text">
                                <span className="num">1</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconI />
                            <div className="desc">{t('sec14_usage2_item3')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.6)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconJ />
                            <div className="desc">{t('sec14_usage2_item4')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.4)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconK />
                            <div className="desc">{t('sec14_usage2_item5')}</div>
                            <div className="data-text">
                                <span className="num">25</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconL />
                            <div className="desc">{t('sec14_usage2_item6')}</div>
                            <div className="data-text">
                                <span className="num">143</span>
                                <span className="unit">{t('sec14_times')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeIdx === 2 && (
                <div className="content-box">
                    <div className="img-box">
                        {!['jp', 'cn'].includes(locale) && (
                            <>
                                {locale === 'au' ? (
                                    <NextImage
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/au_8.jpg')}
                                        alt={t('sec14_title')}
                                        aria-label={t('sec14_title')}
                                    />
                                ) : (
                                    <NextImage
                                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-3.webp')}
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/13-3.jpg')}
                                        alt={t('sec14_title')}
                                        aria-label={t('sec14_title')}
                                    />
                                )}
                            </>
                        )}
                        {locale === 'jp' && (
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-3_jp.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/13-3_jp.jpg')}
                                alt={t('sec14_title')}
                                aria-label={t('sec14_title')}
                            />
                        )}
                        {locale === 'cn' && (
                            <NextImage src={require(`@publicLocal/delta2max/teaser/pc/eu/13-3_cn.jpg`)} alt={t('sec14_title')} aria-label={t('sec14_title')} />
                        )}
                    </div>
                    <div className="icon-box-wrapper wrapper-2">
                        <div className="icon-box">
                            <Icon.IntroIconM />
                            <div className="desc">{t('sec14_usage3_item1')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.2)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconN />
                            <div className="desc">{t('sec14_usage3_item2')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.3)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconO />
                            <div className="desc">{t('sec14_usage3_item3')}</div>
                            <div className="data-text">
                                <span className="num">{intlNumber(locale, 1.5)}</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconP />
                            <div className="desc">{t('sec14_usage3_item4')}</div>
                            <div className="data-text">
                                <span className="num">54</span>
                                <span className="unit">{t('sec14_min')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeIdx === 3 && (
                <div className="content-box">
                    <div className="img-box">
                        {locale !== 'cn' && (
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/13-4.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/13-4.jpg')}
                                alt={t('sec14_title')}
                                aria-label={t('sec14_title')}
                            />
                        )}
                        {locale === 'cn' && (
                            <NextImage src={require(`@publicLocal/delta2max/teaser/pc/eu/13-4_cn.jpg`)} alt={t('sec14_title')} aria-label={t('sec14_title')} />
                        )}
                    </div>
                    <div className="icon-box-wrapper wrapper-3">
                        <div className="icon-box">
                            <Icon.IntroIconQ />
                            <div className="desc">{t('sec14_usage4_item1')}</div>
                            <div className="data-text">
                                <span className="num">99</span>
                                <span className="unit">{t('sec14_times')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconR />
                            <div className="desc">{t('sec14_usage4_item2')}</div>
                            <div className="data-text">
                                <span className="num">26</span>
                                <span className="unit">{t('sec14_times')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconS />
                            <div className="desc">{t('sec14_usage4_item3')}</div>
                            <div className="data-text">
                                <span className="num">39</span>
                                <span className="unit">{t('sec14_times')}</span>
                            </div>
                        </div>
                        <div className="icon-box">
                            <Icon.IntroIconT />
                            <div className="desc">{t('sec14_usage4_item4')}</div>
                            <div className="data-text">
                                <span className="num">97</span>
                                <span className="unit">{t('sec14_hrs')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {t('sec14_desc') && <div className="desc-text">{t('sec14_desc')}</div>}
            <div className="comment-text">{t('sec14_usage_comment')}</div>
            {locale === 'cn' && <p className="sec14-memo">{t('sec14_memo')}</p>}
        </div>
    );
};
